<h2 mat-dialog-title>App Update</h2>
<mat-dialog-content>
  <div class="reload-icon"></div>
  <p class="title">A new version is available.</p>
  <p>Please reload the page for the changes to take effect.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>No</button>
  <button mat-button (click)="reload()">Reload</button>
</mat-dialog-actions>